<template>
  <Dropdown ref="dropdown">
    <template #button="{ open }">
      <button
        type="button"
        class="p-2 rounded-full bg-transparent hover:bg-gray-300 focus:outline-none"
        @click="open"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="12" r="1" />
          <circle cx="12" cy="19" r="1" />
          <circle cx="12" cy="5" r="1" />
        </svg>
      </button>
    </template>
    <div
      class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <div class="py-1">
        <button
          type="button"
          class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
          role="menuitem"
          @click="openPipelineStageEmailMessageManager"
        >
          Email Messages
        </button>
        <button
          type="button"
          class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
          role="menuitem"
          @click="openPipelineStageSmsMessageManager"
        >
          SMS Messages
        </button>
      </div>
    </div>
  </Dropdown>
</template>

<script>
export default {
  props: {
    pipeline: {
      type: Object,
      required: true,
    },
    pipelineStage: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openPipelineStageEmailMessageManager() {
      this.$modal.show({
        component: () =>
          import(
            '@/components/Pipelines/PipelineStageEmailMessageManager/PipelineStageEmailMessageManager.vue'
          ),
        props: {
          pipeline: this.pipeline,
          pipelineStage: this.pipelineStage,
        },
        on: {},
        hideEvent: 'close',
      });
    },
    openPipelineStageSmsMessageManager() {
      this.$modal.show({
        component: () =>
          import(
            '@/components/Pipelines/PipelineStageSmsMessageManager/PipelineStageSmsMessageManager.vue'
          ),
        props: {
          pipeline: this.pipeline,
          pipelineStage: this.pipelineStage,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
